import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files directly
import enTranslations from '../locales/en.json';
import esTranslations from '../locales/es.json';

const resources = {
  en: {
    translation: enTranslations
  },
  es: {
    translation: esTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // NOTE: no `lng` here on purpose. Setting `lng` hard-pins the language and
    // makes LanguageDetector inert, so a saved Spanish preference was thrown
    // away on every reload. `fallbackLng` covers the "nothing detected" case.
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    // 'es-MX', 'es-419', 'en-US' … all resolve to the base bundle.
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    debug: process.env.NODE_ENV === 'development',
    resources,
    interpolation: {
      escapeValue: false
    },
    // A link can pick the language: /storybook?lang=es (the Spanish ads and
    // the Spanish share card, FaceShot-ChopShop-web/lib/page-meta.js) opens
    // in Spanish and remembers it, like the studio's ?lang= hand-off.
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    }
  });

// Keep <html lang> in sync so screen readers and the browser's own
// translate/hyphenation heuristics follow the toggle.
const applyHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng.split('-')[0];
  }
};
applyHtmlLang(i18n.language || 'en');
i18n.on('languageChanged', applyHtmlLang);

export default i18n;
